import { useTranslation } from "react-i18next";
import { Building2 } from "lucide-react";
import { useRef, useEffect } from "react";

const customers = [
  { name: "Voltras", image: "/voltras.png" },
  { name: "PP", image: "/PP.png" },
  { name: "Solusindo", image: "/solusindo.png" },
  { name: "Sandton", image: "/SANDTON.png" },
  { name: "PT. IP TRIBE", image: "/PT.IP TRIBE.png" },
  { name: "RAD", image: "/RAD.png" },
  { name: "Adhikarya", image: "/ADHIKARYA.jpg" },
  { name: "Aktuator", image: "/aktuator.png" },
  { name: "Portal Properti Indonesia", image: "/PT. Portal Properti Indonesia.png" },
  { name: "Altimeda", image: "/Altimeda.png" },
  { name: "Indo Berlian Cemerlang", image: "/PT. INDO BERLIAN CEMERLANG.jpg" },
  { name: "Nadara Digital", image: "/NADARA DIGITAL.png" },
];

export default function CustomersSection() {
  const { t } = useTranslation();
  const trackRef = useRef(null);
  const sliderRef = useRef(null);

  useEffect(() => {
    const track = trackRef.current;
    const slider = sliderRef.current;
    if (!track || !slider) return;

    // Clone each logo once to create a seamless infinite scroll effect.
    // Guard against React StrictMode double-invoking the effect.
    const originalCount = track.children.length;
    if (track.dataset.cloned !== "true") {
      const logos = Array.from(track.children);
      logos.forEach((logo) => {
        track.appendChild(logo.cloneNode(true));
      });
      track.dataset.cloned = "true";
    }

    // Pause animation on hover
    const handleMouseOver = () => {
      track.style.animationPlayState = "paused";
    };
    const handleMouseOut = () => {
      track.style.animationPlayState = "running";
    };

    slider.addEventListener("mouseover", handleMouseOver);
    slider.addEventListener("mouseout", handleMouseOut);

    return () => {
      slider.removeEventListener("mouseover", handleMouseOver);
      slider.removeEventListener("mouseout", handleMouseOut);
      // Remove cloned nodes so a re-mount starts clean (StrictMode / route change)
      while (track.children.length > originalCount) {
        track.removeChild(track.lastChild);
      }
      delete track.dataset.cloned;
    };
  }, []);

  return (
    <section className="py-24 tablet:py-20 px-6 mobile:px-4 bg-surface hairline">
      <div className="container-page">
        <div className="mb-12 max-w-2xl">
          <div className="flex items-center gap-3 mb-4">
            <span className="w-11 h-11 rounded-xl bg-blueLight flex items-center justify-center">
              <Building2 className="w-5 h-5 text-textBlue" aria-hidden="true" />
            </span>
            <span className="kicker">{t("customers.label")}</span>
          </div>
          <h2 className="text-3xl tablet:text-2xl font-semibold tracking-[-0.02em] text-black mb-4">
            {t("customers.title")}
          </h2>
          <p className="text-base text-gray-600 leading-relaxed max-w-[60ch]">
            {t("customers.description")}
          </p>
        </div>

        {/* Infinite Scroll Carousel (animation preserved) */}
        <div className="customer-slider slider-mask hairline" ref={sliderRef}>
          <div className="customer-track" ref={trackRef}>
            {customers.map((customer) => (
              <img
                key={customer.name}
                src={customer.image}
                alt={customer.name}
                width="140"
                height="72"
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
